import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
} from "@mui/material";
import moment from "moment";
import { FormControl } from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { getKycReportList } from "../../redux/actions/getKycReportListAction";
import { getTransactionTypeListDetails } from "../../redux/actions/getTransactionTypeListAction";
import SearchIcon from "@mui/icons-material/Search";
import {
	getKycApproveRejects,
} from "../../redux/actions/getKycApproveRejectAction";
import { Tooltip } from "antd";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";

// import Tooltip from "@mui/material/Tooltip";

import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const KycReport = () => {
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);

	const [isLoading, setIsLoading] = useState(false);
	const [selectedToDate, setSelectedToDate] = useState(new Date());

	const navigate = useHistory();

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [notificationOpen, setNotificationOpen] = useState(false);

	const [getKycReportListStatus, setGetKycReportListStatus] = useState(false);
	const [getKycReportListArray, setGetKycReportListArray] = useState([]);

	const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
		useState([]);

	const [getWalletTransactionListArray, setGetWalletTransactionListArray] =
		useState([]);

	const [getWalletTransactionListStatus, setGetWalletTransactionListStatus] =
		useState(false);

	const [getKycApprovedorRejectStatus, setgetKycApprovedorRejectStatus] =
		useState(false);
	const [getKycApprovedorRejectArray, setgetKycApprovedorRejectArray] =
		useState("");

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const classes = useStyles();
	const dispatch = useDispatch();

	const [user, setUser] = useState({
		verificationId: "",
		walletOwnerId: "",
		parentId: "",
		verificationStatus: "All",
		action: "",
		role: "Select Role"
	});

	const {
		verificationId,
		walletOwnerId,
		parentId,
		verificationStatus,
		action,
		role
	} = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
	};

	const handleDateChange = (date) => {
		setSelectedDate(date);
		if(date > selectedToDate){
			setSelectedToDate(date)
		}
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const getKycReportListRes = useSelector(
		({ getKycReportList }) => getKycReportList
	);

	const getTransactionTypeListRes = useSelector(
		({ getTransactionTypeList }) => getTransactionTypeList
	);

	const getWalletTransactionListRes = useSelector(
		({ getWalletTransactionList }) => getWalletTransactionList
	);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const getKycApproveRejectRes = useSelector(
		({ getKycApproveReject }) => getKycApproveReject
	);

	useEffect(() => {
		getKybApproveRejectResFunc();
	}, [getKycApproveRejectRes.data.status]);

	const getKybApproveRejectResFunc = () => {
		if (getKycApprovedorRejectStatus) {
			if (
				getKycApproveRejectRes.data.status == "success"
			) {
				setgetKycApprovedorRejectArray(getKycApproveRejectRes.data);
				setNotificationOpen(true);
				getKycReportListReq();
			}
			if (
				getKycApproveRejectRes.data.status == "failed"
			) {
				setgetKycApprovedorRejectArray(getKycApproveRejectRes.data);
				setNotificationOpen(true);
				getKycReportListReq();
			}
		}
	};

	const sendVerificationId = (vId, cId, action) => {
		navigate.push({
			pathname: `/index/PartnerViewKycDetails`,
			state: { param1: `${vId}`, param2: `${cId}`, param3: `${action}` }
		});
	};
	const getKycReportListReq = () => {
		setIsLoading(true);
		setGetKycReportListStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				verificationId: verificationId,
				customerId: parentId,
				fdtstamp: moment(selectedDate).format("YYYY/MM/DD"),
				tdtstamp: moment(selectedToDate).format("YYYY/MM/DD"),
				verificationStatus:
					verificationStatus == "All" ? "" : verificationStatus,
				action: action == "Select Action" ? "" : action,
				role: role == "Select Role" ? "" : role
			}
		};
		dispatch(getKycReportList(req, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getKycReportListReq();
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		getKycReportListFunc();
	}, [getKycReportListRes.data.status]);

	const getKycReportListFunc = () => {
		if (getKycReportListStatus) {
			if (getKycReportListRes.data.status == "success") {
				setIsLoading(false);
				setGetKycReportListArray(
					[].concat(getKycReportListRes.data.customerMasterDetailsRequestVOList)
				);
			}
			if (getKycReportListRes.data.status == "failed") {
				setIsLoading(false);
				setGetKycReportListArray(getKycReportListRes.data);
				if (
					getKycReportListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKycReportListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getKycReportListRes.data.status == "Not Found") {
				setIsLoading(false);
				setGetKycReportListArray(getKycReportListRes.data);
			}
		}
	};

	useEffect(() => {
		if (getKycReportListRes.data.status == "success") {
			setPage(0);
		}
	}, [getKycReportListRes.data.status]);

	const getTransactionTypeList = () => {
		if (getTransactionTypeListRes.data.status == "success") {
			setGetTransactionTypeListResArray(
				getTransactionTypeListRes.data.transactionType
			);
		}
	};

	useEffect(() => {
		getTransactionTypeList();
	}, []);

	const getTransactionTypeListReqApi = () => {
		const getTransactionTypeListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(
			getTransactionTypeListDetails(getTransactionTypeListReq, authToken)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getTransactionTypeListReqApi();
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		if (getWalletTransactionListStatus) {
			getWalletTransactionListFun();
		}
	}, [getWalletTransactionListRes.data.status]);

	const getWalletTransactionListFun = () => {
		if (getWalletTransactionListRes.data.status == "success") {
			setGetWalletTransactionListArray(
				[].concat(getWalletTransactionListRes.data.transactionList)
			);
		}
		if (getWalletTransactionListRes.data.status == "failed") {
			setGetWalletTransactionListArray(getWalletTransactionListRes.data);
			if (
				getWalletTransactionListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				getWalletTransactionListRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}

		if (getWalletTransactionListRes.data.status == "Failed") {
			setGetWalletTransactionListArray(getWalletTransactionListRes.data);
			if (
				getWalletTransactionListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				getWalletTransactionListRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}

		if (getWalletTransactionListRes.data.status == "NOT FOUND") {
			setGetWalletTransactionListArray(getWalletTransactionListRes.data);
		}
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const exportToExcel = () => {
		if (getWalletTransactionListArray.length !== undefined) {
			var wb = XLSX.utils.book_new();
			var ws = XLSX.utils.json_to_sheet(getWalletTransactionListArray);
			XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
			XLSX.writeFile(wb, "WalletTransaction.xlsx");
		}
	};

	const exportToPdf = () => {
		const doc = new jsPDF();
		doc.autoTable({
			html: "#walletTransation",
			styles: {
				halign: "center",
				valign: "middle",
				cellWidth: "auto",
				fontSize: 7
			}
		});
		doc.save("WalletTransaction.pdf");
	};

	const handleAcceptOrRejectReq = (
		customerId,
		fileName,
		entity,
		regFraudId,
		action,
		personId,
		role, entityType
	) => {
		setgetKycApprovedorRejectStatus(true);
		const acceptOrRejectReq = {

			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				recommendation: action,
				action: entity,
				customerId: customerId,
				personId: personId == undefined ? "" : personId,
				regFraudId: regFraudId,
				fileName: "",
				role: role,
				entityType: entityType
			}
		};
		return dispatch(getKycApproveRejects(acceptOrRejectReq, authToken));
	};

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
						
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="From Date"
										format="MM/dd/yyyy"
										value={selectedDate}
										onChange={handleDateChange}
										disableFuture={true}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="To Date"
										format="MM/dd/yyyy"
										value={selectedToDate}
										onChange={handleToDateChange}
										disableFuture={true}
										minDate={selectedDate}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={3}>
							<TextField
								size="small"
								color="primary"
								type="text"
								
								label="Verification ID"
								fullWidth={true}
								name="verificationId"
								value={verificationId}
								variant="standard"
								onChange={(e) => onInputChange(e, "number")}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
								style={{ marginTop: "3px" }}
							></TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={4} lg={3}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="Parent ID"
								fullWidth={true}
								name="parentId"
								value={parentId}
								variant="standard"
								
								onChange={(e) => onInputChange(e, "number")}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
								style={{ marginTop: "3px" }}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Verification Status"
								type="name"
								fullWidth
								variant="standard"

								name="verificationStatus"
								defaultValue={"All" || verificationStatus}
								onChange={(e) => onInputChange(e)}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="All" selected="All">
									All
								</MenuItem>
								<MenuItem value="Approve">Approve</MenuItem>
								<MenuItem value="Error">Error</MenuItem>

								<MenuItem value="Failed">Failed</MenuItem>
								<MenuItem value="Pending">Pending</MenuItem>

								<MenuItem value="Reject">Reject</MenuItem>
								<MenuItem value="Review">Review</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Action"
								type="name"
								fullWidth
								name="action"
								variant="standard"

								defaultValue={"Select Action" || action}
								onChange={(e) => onInputChange(e)}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Action" selected="Select Action">
									Select Action
								</MenuItem>
								<MenuItem value="Id_Proof_Verification">
									Id_Proof_Verification
								</MenuItem>
								<MenuItem value="Add_Doc_Verification">
									Add_Doc_Verification
								</MenuItem>
								<MenuItem value="Money_Origin_Form">Money_Origin_Form</MenuItem>


								<MenuItem value="Cust_Verification">Cust_Verification</MenuItem>
								<MenuItem value="Selfie_Verification">Selfie_Verification</MenuItem>

							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								margin="dense"
								id="name"
								label="Role"
								type="name"
								fullWidth
								variant="standard"
								name="role"
								defaultValue={"Select Role" || role}
								onChange={(e) => onInputChange(e)}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="" selected="Select Role">
									Select Role
								</MenuItem>
								<MenuItem value="Customer">Customer</MenuItem>
								<MenuItem value="Merchant">Merchant</MenuItem>
								<MenuItem value="Agent">Agent</MenuItem>
								<MenuItem value="Cashier">Cashier</MenuItem>
								<MenuItem value="Store Manage">Store Manage</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={3}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getKycReportListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getKycReportListArray.length == undefined ||
					!getKycReportListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="text-nowrap my-3">
								<Table className={classes.table}>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Verification ID{" "}
											</TableCell>

											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Parent ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Entity Type
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Role
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												First Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Last Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Verification Status
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Timestamp
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getKycReportListArray &&
											[]
												.concat(getKycReportListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={index}>
														<TableCell
															align="center"
															style={{
																marginTop: "1rem",
																cursor: "pointer",
																fontWeight: "600"
															}}
															className="themeColor"
															onClick={() =>
																sendVerificationId(
																	row.verificationId,
																	row.customerId,
																	row.action
																)
															}
														>
															{row.verificationId}
														</TableCell>

														<TableCell align="center">
															{row.customerId}
														</TableCell>

														<TableCell align="center">
															{row.entityType}
														</TableCell>
														<TableCell align="center">{row.userRole}</TableCell>
														<TableCell align="center">
															{row.firstName}
														</TableCell>

														<TableCell align="center">{row.lastName}</TableCell>
														<TableCell align="center">{row.action}</TableCell>
														<TableCell align="center">
															{row.verificationStatus}
														</TableCell>
														<TableCell align="center">
															{row.requestTime}
														</TableCell>

														{row.verificationStatus == "Pending" && (
															<>
																<TableCell align="center">
																	<Tooltip title="Approve">
																		<CustomButton
																			style={{
																				padding: "8px",
																				width: "50px"
																			}}
																			onClick={() =>
																				handleAcceptOrRejectReq(
																					row.customerId,
																					row.fileName,
																					row.action,
																					row.verificationId,
																					"Approve",
																					row.personId
																				)
																			}
																		>
																			{
																				<ThumbUpAltRoundedIcon
																					style={{
																						color: "#fff",
																						fontSize: "20px"
																					}}
																				/>
																			}
																		</CustomButton>
																	</Tooltip>

																	<Tooltip title="Reject">
																		<CustomButton
																			style={{
																				padding: "4px",
																				width: "48px",
																				marginLeft: "5px"
																			}}
																			onClick={() =>
																				handleAcceptOrRejectReq(
																					row.customerId,
																					row.fileName,
																					row.action,
																					row.verificationId,
																					"Reject",
																					row.personId,
																					row.userRole,
																					row.entityType
																				)
																			}
																		>
																			{
																				<ClearRoundedIcon
																					style={{
																						color: "#fff",
																						fontSize: "28px"
																					}}
																				/>
																			}
																		</CustomButton>
																	</Tooltip>
																</TableCell>
															</>
														)}

														{row.verificationStatus == "Approval Pending" && (
															<>
																<TableCell align="center">
																	<Tooltip title="Approve">
																		<CustomButton
																			style={{
																				padding: "8px",
																				width: "50px"
																			}}
																			onClick={() =>
																				handleAcceptOrRejectReq(
																					row.customerId,
																					row.fileName,
																					row.action,
																					row.verificationId,
																					"Approve",
																					row.personId
																				)
																			}
																		>
																			{
																				<ThumbUpAltRoundedIcon
																					style={{
																						color: "#fff",
																						fontSize: "20px"
																					}}
																				/>
																			}
																		</CustomButton>
																	</Tooltip>

																	<Tooltip title="Reject">
																		<CustomButton
																			style={{
																				padding: "4px",
																				width: "48px",
																				marginLeft: "5px"
																			}}
																			onClick={() =>
																				handleAcceptOrRejectReq(
																					row.customerId,
																					row.fileName,
																					row.action,
																					row.verificationId,
																					"Reject",
																					row.personId
																				)
																			}
																		>
																			{
																				<ClearRoundedIcon
																					style={{
																						color: "#fff",
																						fontSize: "28px"
																					}}
																				/>
																			}
																		</CustomButton>
																	</Tooltip>
																</TableCell>
															</>
														)}

														{row.verificationStatus == "Approve" && (
															<>
																<TableCell align="center">
																	<Tooltip title="Approve">
																		<CustomButton
																			style={{
																				padding: "8px",
																				width: "50px"
																			}}
																			disabled
																		>
																			{
																				<ThumbUpAltRoundedIcon
																					style={{
																						color: "#fff",
																						fontSize: "20px"
																					}}
																				/>
																			}
																		</CustomButton>
																	</Tooltip>

																	<Tooltip title="Reject">
																		<CustomButton
																			style={{
																				padding: "4px",
																				width: "48px",
																				marginLeft: "5px"
																			}}
																			disabled
																		>
																			{
																				<ClearRoundedIcon
																					style={{
																						color: "#fff",
																						fontSize: "28px"
																					}}
																				/>
																			}
																		</CustomButton>
																	</Tooltip>
																</TableCell>
															</>
														)}

														{row.verificationStatus == "Reject" && (
															<>
																<TableCell align="center">
																	<Tooltip title="Approve">
																		<CustomButton
																			style={{
																				padding: "8px",
																				width: "50px"
																			}}
																			disabled={true}
																		>
																			{
																				<ThumbUpAltRoundedIcon
																					style={{
																						color: "#fff",
																						fontSize: "20px"
																					}}
																				/>
																			}
																		</CustomButton>
																	</Tooltip>

																	<Tooltip title="Reject">
																		<CustomButton
																			style={{
																				padding: "4px",
																				width: "48px",
																				marginLeft: "5px"
																			}}
																			disabled={true}
																		>
																			{
																				<ClearRoundedIcon
																					style={{
																						color: "#fff",
																						fontSize: "28px"
																					}}
																				/>
																			}
																		</CustomButton>
																	</Tooltip>
																</TableCell>
															</>
														)}
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={[].concat(getKycReportListArray).length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				{getWalletTransactionListArray.length == undefined ||
					!getWalletTransactionListStatus ? (
					<Card style={{ display: "none" }}></Card>
				) : (
					<div style={{ display: "none" }}>
						<TableContainer component={Paper}>
							<Table className={classes.table} id="walletTransation">
								<TableHead className="themeBackground">
									<TableRow>
										<TableCell align="center">Transaction Date </TableCell>
										<TableCell align="center"> Transaction Id</TableCell>
										<TableCell align="center"> Transaction Type</TableCell>

										<TableCell align="center">Transaction Amount</TableCell>
										<TableCell align="center">DSR Contact</TableCell>
										<TableCell align="center">To Customer</TableCell>

										<TableCell align="center">Commission</TableCell>
										<TableCell align="center">Credit</TableCell>
										<TableCell align="center">Debit</TableCell>

										<TableCell align="center">Balance</TableCell>
										<TableCell align="center">Transaction Status</TableCell>
										<TableCell align="center">Remark</TableCell>
									</TableRow>
								</TableHead>

								<TableBody>
									{getWalletTransactionListArray &&
										[]
											.concat(getWalletTransactionListArray)
											.map((row, index) => (
												<TableRow key={index}>
													<TableCell align="center">{row.fromDate}</TableCell>
													<TableCell align="center">
														{row.transactionId}
													</TableCell>
													<TableCell align="center">
														{row.transactionType}
													</TableCell>

													<TableCell align="center">
														{row.transactionAmount}
													</TableCell>
													<TableCell align="center"></TableCell>
													<TableCell align="center">
														{row.toCustomerName}
													</TableCell>

													<TableCell align="center"></TableCell>
													<TableCell align="center">
														{row.creditAmount}
													</TableCell>
													<TableCell align="center">
														{row.debitAmount}
													</TableCell>

													<TableCell align="center">{row.balance}</TableCell>
													<TableCell align="center">
														{row.transactionStatus}
													</TableCell>
													<TableCell align="center">{row.remark}</TableCell>
												</TableRow>
											))}
								</TableBody>
							</Table>
						</TableContainer>
					</div>
				)}
			</Layout>
			{getKycApprovedorRejectArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{getKycApprovedorRejectArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{getKycApprovedorRejectArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{getKycApprovedorRejectArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default KycReport;
